import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { NOT_DEFINED_DELIVERY_CARRIER_ID, OrderStateStatus } from '../../constants';
import { DeliveryTracking, ExpectedDeliveryPeriod } from '../../models';

@Component({
  selector: 'app-order-line-delivery',
  templateUrl: './order-line-delivery.component.html',
  styleUrls: ['./order-line-delivery.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderLineDeliveryComponent {
  @Input() expectedDeliveryPeriod: ExpectedDeliveryPeriod;
  @Input() trackings: DeliveryTracking[];
  @Input() status: OrderStateStatus;

  public notDefinedCarrierId = NOT_DEFINED_DELIVERY_CARRIER_ID;

  public get isShipped(): boolean {
    return this.status === OrderStateStatus.SHIPPED;
  }

  public get isPeriodEnabled(): boolean {
    return (
      Boolean(this.expectedDeliveryPeriod?.start) &&
      [OrderStateStatus.PLACED, OrderStateStatus.CONFIRMED, OrderStateStatus.SHIPPED].includes(this.status)
    );
  }
}
